import type { AccessGroupCreationUiPhase, AccessGroupFormStepId } from '@/types/accessGroupCreation';
import { staticDefaults } from '@/config/static/catalog';

export const ADD_ACCESS_GROUP_FLOW_TITLE = 'Create an access group';

export const ACCESS_GROUP_UI_PHASES: { id: AccessGroupCreationUiPhase; figmaLabel: string }[] = [
  { id: 'thinking', figmaLabel: 'Thinking...' },
  { id: 'working', figmaLabel: 'Working on it...' },
  { id: 'almost-ready', figmaLabel: 'Almost ready..' },
  { id: 'form', figmaLabel: 'Create access group form' },
  { id: 'saving', figmaLabel: 'Saving' },
  { id: 'success', figmaLabel: 'Access group created' },
];

export const ACCESS_GROUP_FORM_STEPS: { id: AccessGroupFormStepId; label: string }[] = [
  { id: 'details', label: 'Details' },
];

export const ACCESS_GROUP_PROGRESS_RAIL_STEPS = [
  { id: 'access', label: 'Checking your access' },
  { id: 'system', label: 'Confirming the system' },
  { id: 'validate', label: 'Validating group info' },
  { id: 'preview', label: 'Building your preview' },
] as const;

export const ACCESS_GROUP_CREATION_TIMING = {
  thinkingMs: 900,
  progressStepMs: [750, 3000, 3000, 800] as const,
  almostReadyMs: 700,
  formRevealMs: 500,
  savingMs: 4000,
} as const;

export const ACCESS_GROUP_SCHEDULES = [
  'Always (24/7)',
  'Business Hours (8AM–6PM)',
  'Extended Hours (6AM–10PM)',
  'Weekdays Only',
] as const;

export const DEVICE_READERS = [
  {
    value: 'reader-main',
    label: 'Reader 1 — Main entrance',
    description: 'Device 1 · Axis A1001',
  },
  {
    value: 'reader-side',
    label: 'Reader 2 — Side entrance',
    description: 'Device 1 · Axis A1001',
  },
  {
    value: 'reader-lab',
    label: 'Reader 1 — Lab',
    description: 'Device 1 · Axis A1001',
  },
  {
    value: 'reader-loading',
    label: 'Reader 1 — Loading bay',
    description: 'Device 2 · Axis A1001',
  },
  {
    value: 'reader-server',
    label: 'Reader 3 — Server room',
    description: 'Device 3 · Axis A1001',
  },
] as const;

/** @deprecated Use staticDefaults.accessGroup.defaultDraft */
export const DUMMY_ACCESS_GROUP_DEFAULT_DRAFT = { ...staticDefaults.accessGroup.defaultDraft };

/** Operator flow — fields that show the “AI generated” tag. */
export const OPERATOR_ACCESS_GROUP_AI_FILLED_FIELDS = [
  ...staticDefaults.accessGroup.operatorAiFilledFields,
];

export const OPERATOR_ACCESS_GROUP_ASSISTANT_HINT =
  staticDefaults.accessGroup.operatorAssistantHint;

/** @deprecated Use staticDefaults.accessGroup.success */
export const DUMMY_ACCESS_GROUP_SUCCESS = { ...staticDefaults.accessGroup.success };

/** @deprecated Use staticDefaults.accessGroup.explainability */
export const DUMMY_ACCESS_GROUP_EXPLAINABILITY = staticDefaults.accessGroup.explainability;

/** @deprecated Use staticDefaults.accessGroup.assistantHint */
export const DUMMY_ACCESS_GROUP_ASSISTANT_HINT = staticDefaults.accessGroup.assistantHint;
